import React from 'react';
import { DetectionTestDefinition, DetectionTestDefinitionInput } from 'Generated/schema';
import { ConfirmModalV3 } from '../ConfirmModal';

export interface DeleteTestModalProps {
  test: DetectionTestDefinition | DetectionTestDefinitionInput;
  onConfirm: () => void;
}

const DeleteTestModalV3: React.FC<DeleteTestModalProps> = ({ test, onConfirm, ...rest }) => {
  return (
    <ConfirmModalV3
      variant="destructive"
      subtitle={`Are you sure you want to delete ${test.name}?`}
      onConfirm={onConfirm}
      {...rest}
    />
  );
};

export default DeleteTestModalV3;
